export default class Toc {
    constructor( toc ) {
        this.toc = toc;
        this.list = toc.querySelector( '.toc__list' );

        this.render();
    }

    collectHeadings() {
        const headings = document.querySelectorAll( '.page__main h2' );

        // Section headings are element headers rendered with a c<uid> anchor id
        // or headings inside rich text; promotional CTA headers are no sections.
        return Array.prototype.filter.call( headings, ( heading ) => {
            if ( heading.closest( '.toc, .call-to-action' ) !== null ) {
                return false;
            }

            return ( /^c\d+$/ ).test( heading.id ) || heading.closest( '.text__body' ) !== null;
        } );
    }

    createAnchorId( heading ) {
        if ( heading.id ) {
            return heading.id;
        }

        const slug = heading.textContent
            .trim()
            .toLowerCase()
            .replace( /ä/g, 'ae' )
            .replace( /ö/g, 'oe' )
            .replace( /ü/g, 'ue' )
            .replace( /ß/g, 'ss' )
            .replace( /[^a-z0-9]+/g, '-' )
            .replace( /^-+|-+$/g, '' ) || 'abschnitt';

        let id = slug;
        let counter = 2;

        while ( document.getElementById( id ) ) {
            id = slug + '-' + counter;
            counter++;
        }

        heading.id = id;

        return id;
    }

    render() {
        const headings = this.collectHeadings();

        if ( !this.list || headings.length === 0 ) {
            this.toc.hidden = true;
            return;
        }

        for ( const heading of headings ) {
            const id = this.createAnchorId( heading );

            const item = document.createElement( 'li' );
            item.className = 'toc__item';

            const link = document.createElement( 'a' );
            link.className = 'toc__link';
            link.href = '#' + id;
            link.textContent = heading.textContent.trim();

            item.appendChild( link );
            this.list.appendChild( item );
        }
    }
}
